import $ from 'jquery';

require('what-input');
var objectFitImages = require('object-fit-images');

$(document).ready(function () {
	//Require all components here.
	require('./components/foundation');
	require('./components/menu');
	require('./components/icon-block');
	require('./components/menu-mobile');
	require('./components/slider');
	require('./components/brands');
	require('./components/search');
	require('./components/vacancy-form-scroll');
	require('./components/social-share');
	require('./components/carousel');
	require('./components/read-more');
	require('./components/google-maps');
	require('./components/product-journey');

	objectFitImages();
});
